import {Action, getModule, Module, Mutation, VuexModule} from "vuex-module-decorators";
import store from "../index";
import {Product, ProductApi} from "@/client/index";
import {BASE_PATH} from "@/main";

@Module({
    store,
    dynamic: true,
    name: 'service',
    namespaced: true
})
export default class ProfileStore extends VuexModule {

    profile: any = null

    @Mutation
    public updateProfile(event: CustomEvent) {
        this.profile = event.detail.profile
    }

}

const profileStore = getModule(ProfileStore)
window.addEventListener('vuexoidc:userLoaded', profileStore.updateProfile)
